// Full-screen switch: a HUD button and the F key.
import { tr } from './lang.js';
import { bFull } from '../dom.js';

// Where the Fullscreen API is missing (iPhone Safari) the button stays hidden.
const supported = () => !!document.fullscreenEnabled;

export function setFullscreenLabel() {
  const title = tr(document.fullscreenElement ? 'exitFullscreen' : 'fullscreen');
  bFull.title = title;
  bFull.setAttribute('aria-label', title);
  bFull.textContent = document.fullscreenElement ? '✕' : '⛶';
}

export function buildFullscreen() {
  if (!supported()) {
    bFull.hidden = true;
    return;
  }
  const toggle = () => {
    if (document.fullscreenElement) document.exitFullscreen();
    else document.documentElement.requestFullscreen({ navigationUI: 'hide' }).catch(() => {});
  };
  bFull.onclick = () => {
    toggle();
    bFull.blur();
  };
  addEventListener('keydown', (e) => {
    // the splash covers the page until START; the browser's own Esc leaves full screen
    if (e.code !== 'KeyF' || e.repeat || e.ctrlKey || e.metaKey || e.altKey) return;
    if (document.getElementById('splash')) return;
    toggle();
  });
  document.addEventListener('fullscreenchange', setFullscreenLabel);
  setFullscreenLabel();
}
